import apiClient from './client'

interface AskResponse {
  answer: string
}

/**
 * Ask the RAG chatbot a question. `language` is the visitor's active site
 * language (i18next). The backend rate-limits this endpoint and returns HTTP
 * 429 when the caller exceeds RAG_RATE_LIMIT; callers should use
 * `isRateLimited` from ./errors to tell that apart from a generic failure.
 */
export async function askChat(
  question: string,
  language: string,
): Promise<string> {
  const { data } = await apiClient.post<AskResponse>('/rag/ask', {
    question,
    language,
  })
  return data.answer
}
